<div class="popup-wrap2"
     (click)="onVoid($event)">

  <article class="popup-connect-box">

    <div class="connect-head">
      <div class="head-box">
        <div class="hun">{{ hun }}</div>
      </div>
    </div>

    <div class="connect-body">
      <div class="hun-list">
        <div class="hun-box"
             *ngFor="let hanja of listSaseungHanja">
          <app-hun-hanja-item class="hun-box"
                              [hun]="hun"
                              [hanja]="hanja"
                              (afterViewInit)="onItemAfterViewInit()">
          </app-hun-hanja-item>
        </div>
      </div>
    </div>

    <div *ngIf="IsLoading"
         class="connect-body">
      <div class="reload-icon">
        <img src="assets/img/loading_icon.gif">
      </div>
    </div>

    <!-- div class="connect-body"
         *ngIf="getMoreTxt()" -->
    <div class="connect-tail">
      <div class="more-link-btn-box">
        <a class="more-link-btn"
           (click)="onCloseMore($event)">{{ getLeftHunCount() > 0 ? '더 보기' : '자세히 보기' }}</a>
        <div *ngIf="getLeftHunCount() > 0"
             class="more-txt">{{ getMoreTxt() }}</div>
      </div>

      <div class="menu-box">
        <a class="close-btn"
           (click)="onClose($event)"></a>
      </div>

    </div>

  </article>
</div>
